import TableData from "components/TableData";
import React from 'react';
import {Form, FormControl, Nav, Navbar, NavDropdown} from "react-bootstrap";


const Home = props => {

    return (
        <div className="home">
            <TableData/>
        </div>
    );
};

export default Home;